import React from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
const Brands = () => {
    const { t } = useTranslation();
    const storeFrontData = useSelector((state) => state.app.storeData);
    const brands = storeFrontData.brands;
    return (
        <div className="p-2 lg:p-8 m-2 bg-gry-200 rounded-2xl">
            <div className="flex justify-between items-center mb-5 mt-5">
                <h1 className="font-bold text-xl">{t('shop_by_brands')}</h1>
                <Link className="text-sm border rounded-full px-5 py-2 font-bold"
                    to={"/brands"}
                >
                    {t('see_all')}
                </Link>
            </div>
            <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-px bg-gray-100 overflow-hidden rounded-2xl border border-gray-200">
                {brands.map((brand) => (
                    <div
                        key={brand.id}
                        className="flex items-center justify-center bg-white"
                    >
                        <Link
                            to={"shop/brand/" + brand.id + "/" + brand.brand_name}
                        >
                            <img
                                loading="lazy"
                                src={brand.brand_logo}
                                alt={brand.brand_name}
                            />
                        </Link>
                    </div>
                ))}
            </div>
        </div>
    );
}
export default Brands;